// Personal Notes API — multi-note CRUD scoped to the authenticated user.
import axios from 'axios';
import { API_URL } from '../../api/api';

const base = `${API_URL}/api/personal-notes`;

const auth = () => {
  const token = localStorage.getItem('token');
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export const notesApi = {
  list: (q) =>
    axios
      .get(base, { ...auth(), params: q ? { q } : {} })
      .then((r) => (Array.isArray(r.data) ? r.data : [])),
  // create/update accept the full note payload, including `remind_at`
  // (an ISO string to arm a reminder, or null to clear it).
  create: (payload) => axios.post(base, payload, auth()).then((r) => r.data),
  update: (id, patch) => axios.put(`${base}/${id}`, patch, auth()).then((r) => r.data),
  remove: (id) => axios.delete(`${base}/${id}`, auth()).then((r) => r.data),
  // Sharing — notes shared with me (read-only), colleagues I can share with,
  // and per-note recipient management.
  listShared: () =>
    axios.get(`${base}/shared`, auth()).then((r) => (Array.isArray(r.data) ? r.data : [])),
  listColleagues: () =>
    axios.get(`${base}/colleagues`, auth()).then((r) => (Array.isArray(r.data) ? r.data : [])),
  getShares: (id) =>
    axios.get(`${base}/${id}/shares`, auth()).then((r) => (Array.isArray(r.data) ? r.data : [])),
  share: (id, userIds) =>
    axios.post(`${base}/${id}/share`, { user_ids: userIds }, auth()).then((r) => r.data),
  unshare: (id, userId) =>
    axios.delete(`${base}/${id}/share/${userId}`, auth()).then((r) => r.data),
};

// Shared colour-label palette for notes (value stored in DB, swatch in UI).
export const NOTE_COLORS = [
  { key: 'none', label: 'None', value: null, swatch: '#e5e7eb' },
  { key: 'orange', label: 'Orange', value: '#f54b01', swatch: '#f54b01' },
  { key: 'amber', label: 'Amber', value: '#f59e0b', swatch: '#f59e0b' },
  { key: 'green', label: 'Green', value: '#00a63e', swatch: '#00a63e' },
  { key: 'blue', label: 'Blue', value: '#2b7fff', swatch: '#2b7fff' },
  { key: 'purple', label: 'Purple', value: '#8e51ff', swatch: '#8e51ff' },
  { key: 'red', label: 'Red', value: '#e7000b', swatch: '#e7000b' },
];
